<template>
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        width="24.000000" height="24.000000" fill="none">
        <rect id="svg" width="24.000000" height="24.000000" x="0.000000" y="0.000000" />
        <rect id="4922" width="20.000000" height="16.000000" x="2.000000" y="4.000000" rx="2.000000"
            stroke="rgb(80,200,120)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.000000" />
        <path id="4923"
            d="M22 7L13.03 12.7C12.7213 12.8934 12.3643 12.996 12 12.996C11.6357 12.996 11.2787 12.8934 10.97 12.7L2 7"
            fill-rule="nonzero" stroke="rgb(80,200,120)" stroke-linecap="round" stroke-linejoin="round"
            stroke-width="2.000000" />
    </svg>
</template>
